<template>
    <div class="body-repeat-custom">
        <div class="border-repeat-custom">
            <div class="text-title">自定义重复</div>
            <div class="items-type">
                <div class="item-type my-cursor"
                     @click.stop="setRepeat(item.repeatType)"
                     v-for="item in typeItems">
                    <div class="text-type">{{ item.text }}</div>
                    <div class="img-repeat-line"
                         :style="{visibility: item.repeatType === topType ? 'visible': 'hidden'}"></div>
                </div>
            </div>
            <RepeatDay v-if="topType === 'custom_day'"
                       :repeatCycle="custom_day.repeatCycle"
                       :skipHolidaysState="skipState"
                       @submitSkipState="saveSkipState($event)"
                       @submitEvent="saveRepeat($event)"
            />
            <RepeatWeek v-if="topType === 'custom_week'"
                        :repeatInfo="custom_week.repeatInfo"
                        :skipHolidaysState="skipState"
                        @submitSkipState="saveSkipState($event)"
                        @submitEvent="saveRepeat($event)"
            />
            <RepeatMonth v-if="topType === 'custom_month'"
                         :custom_month="custom_month"
                         :month_week="month_week"
                         :skipHolidaysState="skipState"
                         @submitSkipState="saveSkipState($event)"
                         @submitTypeEvent="saveTypeEvent()"
                         @submitEvent="saveRepeat($event)"
            />
            <RepeatYear v-if="topType === 'custom_year'"
                        :repeatInfo="custom_year.repeatInfo"
                        :skipHolidaysState="skipState"
                        @submitSkipState="saveSkipState($event)"
                        @submitEvent="saveRepeat($event)"
            />
            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import RepeatDay from "./RepeatDay";
import RepeatWeek from "./RepeatWeek";
import RepeatMonth from "./RepeatMonth";
import RepeatYear from "./RepeatYear";
export default {
    name: "RepeatCustom",
    components: {
        RepeatDay,
        RepeatWeek,
        RepeatMonth,
        RepeatYear,
    },
    data(){
        return {
            topType: "",
            custom_day: {
                repeatType: "custom_day",
                repeatCycle: 1,
                repeatInfo: "",
            },
            custom_week: {
                repeatType: "custom_week",
                repeatCycle: 1,
                repeatInfo: "",
            },
            custom_month: {
                repeatType: "custom_month",
                repeatCycle: 1,
                repeatInfo: "",
                state: true,
            },
            month_week: {
                repeatType: "month_week",
                repeatCycle: 1,
                repeatInfo: "",
                state: false,
            },
            custom_year: {
                repeatType: "custom_year",
                repeatCycle: 1,
                repeatInfo: "",
            },
            skipState: 0,
            typeItems: [
                {
                    repeatType: "custom_day",
                    text: "每日",
                },{
                    repeatType: "custom_week",
                    text: "每周",
                },{
                    repeatType: "custom_month",
                    text: "每月",
                },{
                    repeatType: "custom_year",
                    text: "每年",
                }
            ],
        }
    },
    props: {
        repeatType: {
            type: String,
            default: "",
        },
        repeatCycle: {
            type: Number,
            default: 1,
        },
        repeatInfo: {
            type: String,
            default: "",
        },
        skipHolidaysState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            let repeatItem;
            if(this.topType === "custom_month" && this.month_week.state){
                repeatItem = this.month_week;
            }else{
                repeatItem = this[this.topType];
            }
            repeatItem.skipHolidaysState = this.skipState;

            this.$emit("submitEvent", repeatItem);
            this.close();
        },
        setRepeat: function(repeatType){
            this.topType = repeatType;
        },
        saveRepeat: function(e){
            this[e.repeatType].repeatType = e.repeatType;
            this[e.repeatType].repeatCycle = parseInt(e.repeatCycle);
            this[e.repeatType].repeatInfo = e.repeatInfo;
        },
        saveSkipState: function(e){
            this.skipState = e;
        },
        saveTypeEvent: function(){
            this.custom_month.state = !this.custom_month.state;
            this.month_week.state = !this.month_week.state;
        },

    },
    mounted(){
        let topType;
        if(this.repeatType === "custom_day"){
            topType = "custom_day";
            this.custom_day.repeatInfo = this.repeatInfo;
            this.custom_day.repeatCycle = this.repeatCycle;
        }else if(this.repeatType === "custom_week"){
            topType = "custom_week";
            this.custom_week.repeatInfo = this.repeatInfo;
            this.custom_week.repeatCycle = this.repeatCycle;
        }else if(this.repeatType === "custom_month"){
            topType = "custom_month";
            this.custom_month.repeatInfo = this.repeatInfo;
            this.custom_month.repeatCycle = this.repeatCycle;
            this.custom_month.state = true;
            this.month_week.state = false;

        }else if(this.repeatType === "month_week"){
            topType = "custom_month";
            this.month_week.repeatInfo = this.repeatInfo;
            this.month_week.repeatCycle = this.repeatCycle;
            this.custom_month.state = false;
            this.month_week.state = true;
        }else if(this.repeatType === "custom_year"){
            topType = "custom_year";
            this.custom_year.repeatInfo = this.repeatInfo;
            this.custom_year.repeatCycle = this.repeatCycle;
        }else{
            topType = "custom_day";
        }
        this.topType = topType;
        this.skipState = this.skipHolidaysState;

    },
}
</script>

<style scoped>
div.body-repeat-custom{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-repeat-custom{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.items-type{
    width: 100%;
    padding: 0 0.15rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 0.24rem;
}
div.text-type{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.img-repeat-line{
    width: 0.46rem;
    height: 0.07rem;
    background: url("../../../assets/images/List/img-repeat-line.png");
    background-size: cover;
    margin: -0.07rem auto auto;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>